import ChartBaseController from './chart_base_controller';
import { handleChartError, withErrorHandling } from './chart_error_handler';

export default class ChartBarStackedBenchmarkController extends withErrorHandling(ChartBaseController) {
  campaignData = null;

  static values = {
    ...ChartBaseController.values,
    xKey: String,
    yKeys: Array,
    direction: String,
  }

  chartBarStackedTheme = {
    palette: {
      fills: ["#F44336", "#FF9800", "#00C853"]
    }
  }

  formatData(data) {
    // Handle potential errors
    const result = handleChartError(data, this.chartTarget);
    if (result.hasError) {
      this.hasError = true;
      return result.formattedData || [];
    }

    // Reset error flag
    this.hasError = false;

    // Store the original JSON response for series formatting
    this.campaignData = data;

    const allRatings = [];
    data.forEach(campaign => {
      const ratings = { ...campaign.ratings };
      // Add unique identifiers for stacked charts
      ratings.campaign_unique_id = campaign.campaign_unique_id;
      ratings.campaign_display_name = campaign.campaign_display_name;
      allRatings.push(ratings);
    });
    return allRatings;
  }

  getChartOptions(data) {
    const options = super.getChartOptions(data);

    // Only format series if valid campaign data exists
    if (this.campaignData && !this.campaignData.error && Array.isArray(this.campaignData)) {
      options.series = this.formatSeries(this.campaignData);
      options.theme = this.chartBarStackedTheme;

      // Add custom axis label formatter to show display names
      options.axes = [{
        type: 'category',
        position: 'left',
        label: {
          formatter: (params) => {
            // Find the corresponding ratings data to get display name
            const ratingsItem = data.find(ratings => ratings.campaign_unique_id === params.value);
            return ratingsItem ? ratingsItem.campaign_display_name : params.value;
          }
        }
      }, {
        type: 'number',
        position: 'bottom'
      }];
    }

    return options;
  }


  formatSeries() {
    const series = []
    this.yKeysValue.forEach((yKey) => {
      series.push({
        type: 'bar',
        label: {
          formatter: function(params) {
            return params.value.toString();
          },
          enabled: true,
          fontSize: 18,
        },
        direction: 'horizontal',
        xKey: 'campaign_unique_id',
        yKey: yKey,
        yName: yKey,
        normalizedTo: 100,
        stacked: true,
      });
    });
    return series;
  }
}
